import {
  CommandRoot,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from '@discover-ui/command';
import CheckIcon from '@discover-ui/icons/check.svg';
import { cn } from '@discover-lib/utils';
import { TrackProvider } from '@/components/analytics/context/AnalyticsContext';
import { useAnalytics } from '@/components/analytics/hooks/useAnalytics';

export type Option = { value: string; label: string };

export type OptionListProps = {
  options: Option[];
  setOpen: (open: boolean) => void;
  value?: string | null;
  setValue: (value: string | undefined) => void;
  isSelected?: (value: string) => boolean;
  placeholder: string;
  multiple?: boolean;
  className?: string;
};

export default function OptionList({
  options,
  setOpen,
  value,
  setValue,
  isSelected = (optionValue) => optionValue === value,
  placeholder,
  multiple,
  className,
}: OptionListProps) {
  const { track } = useAnalytics();

  return (
    <CommandRoot className={cn('rounded-none', className)}>
      <CommandInput className="my-2" placeholder={placeholder} />
      <CommandList className="max-h-full sm:max-h-[300px]">
        <CommandEmpty>No results found.</CommandEmpty>
        <CommandGroup>
          {options.map((option) => (
            <TrackProvider key={option.value} button_name={placeholder}>
              <CommandItem
                value={option.label.trim()}
                onSelect={(newLabel) => {
                  const wasSelected = isSelected(option.value);
                  setValue(
                    options.find(({ label: optionLabel }) => optionLabel.trim() === newLabel)?.value
                  );
                  if (placeholder === 'Pick a suburb' && !wasSelected) {
                    track('location_selected', {
                      option_selected_name: option.label,
                      option_selected_id: option.value,
                    });
                  }
                  if (!multiple) {
                    setOpen(false);
                  }
                }}
                disabled={false}>
                <CheckIcon
                  className={cn(
                    'mr-2 size-4',
                    isSelected(option.value) ? 'opacity-100' : 'opacity-0'
                  )}
                />
                {option.label}
              </CommandItem>
            </TrackProvider>
          ))}
        </CommandGroup>
      </CommandList>
    </CommandRoot>
  );
}
